// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__yFQzh","category":"styles_category__Scvel","text":"styles_text__LrvRa","wrap":"styles_wrap__0QyYr"};